
import axios from 'axios';
import config from '../config/config';
import { getAuthToken } from '../utils/token';

const BASE_URL = `${config.API}/warehouses`;

const getAuthConfig = () => {
    const token = getAuthToken();

    return {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    };
};

/**
 * Get all warehouse records with optional filters.
 * GET /api/warehouses
 */
export const getWarehouses = async (params = {}) => {
    const response = await axios.get(
        BASE_URL,
        {
            ...getAuthConfig(),
            params,
        }
    );

    return response.data;
};

/**
 * Get a warehouse record by ID.
 * GET /api/warehouses/{id}
 */
export const getWarehouseById = async (id) => {
    const response = await axios.get(
        `${BASE_URL}/${id}`,
        getAuthConfig()
    );

    return response.data;
};

/**
 * Create a warehouse record.
 * POST /api/warehouses
 */
export const createWarehouse = async (data) => {
    const response = await axios.post(
        BASE_URL,
        data,
        getAuthConfig()
    );

    return response.data;
};

/**
 * Update a warehouse record.
 * PUT /api/warehouses/{id}
 */
export const updateWarehouse = async (id, data) => {
    const response = await axios.put(
        `${BASE_URL}/${id}`,
        data,
        getAuthConfig()
    );

    return response.data;
};

/**
 * Partially update a warehouse record.
 * PATCH /api/warehouses/{id}
 */
export const patchWarehouse = async (id, data) => {
    const response = await axios.patch(
        `${BASE_URL}/${id}`,
        data,
        getAuthConfig()
    );

    return response.data;
};

/**
 * Logically delete a warehouse record.
 * DELETE /api/warehouses/{id}
 */
export const deleteWarehouse = async (id) => {
    const response = await axios.delete(
        `${BASE_URL}/${id}`,
        getAuthConfig()
    );

    return response.data;
};

/**
 * Restore a logically deleted warehouse record.
 * POST /api/warehouses/{id}/restore
 */
export const restoreWarehouse = async (id) => {
    const response = await axios.post(
        `${BASE_URL}/${id}/restore`,
        {},
        getAuthConfig()
    );

    return response.data;
};
